module.exports = __webpack_public_path__ + "img/thumb-preirisotto-met-fetakaas.253011d5.jpeg";